<template>
  <button
    @click="toggleTheme"
    class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-800"
    :title="isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'"
  >
    <i v-if="isDark" class="pi pi-sun text-gray-600 dark:text-gray-400"></i>
    <i v-else class="pi pi-moon text-gray-600 dark:text-gray-400"></i>
  </button>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores/theme'
import { storeToRefs } from 'pinia'

const themeStore = useThemeStore()
const { isDark } = storeToRefs(themeStore)
const { toggleTheme } = themeStore
</script>